<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      lazy
      :persistent="shapeUpdate"
      max-width="640"
    >
      <v-card class="c parking-space-detail" v-if="loading">
        <v-layout row wrap fill-height class="is-100 justify-center" pa-4>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-card>
      <v-card class="c parking-space-detail" v-else>
        <v-card-title>
          <v-layout row wrap class="is-100">
            <v-flex>
              <h3 class="headline" :class="{'error--text': data.occupied}">{{ data.name }}</h3>
            </v-flex>
          </v-layout>
          <v-tabs slot="extension" v-model="tab" color="white" grow>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>
              Übersicht
            </v-tab>
            <v-tab>
              Parkvorgänge
            </v-tab>
            <v-tab>
              Einstellungen
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-card-text>
          <div v-show="tab === 0">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <simple-statistic
                  :value="statistics.movements"
                  type="number"
                  label="Parkvorgänge heute"
                ></simple-statistic>
              </v-flex>
              <v-flex xs12 md6>
                <simple-statistic
                  :value="(statistics.avg_duration ? statistics.avg_duration.secs : 0) | durationFromSeconds"
                  suffix="h"
                  type="time"
                  label="ø Parkdauer heute"
                ></simple-statistic>
              </v-flex>
            </v-layout>
            <!-- <overview-statistics v-bind:statistics="statistics"></overview-statistics> -->
          </div>
          <div v-show="tab === 1">
            <parking-table :data="parkingEvents"></parking-table>
          </div>
          <div v-show="tab === 2">
            <data-editor
              :type="data.type"
              :sensor-model="data.sensor_model"
              :name="data.name"
              @delete="onParkingSpaceDeleted"
              @save="onParkingSpaceUpdate"
              @update-shape="onParkingSpaceShapeUpdate"></data-editor>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="toggle">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ParkingTable from '../Metrics/ParkingTable.vue';
import OverviewStatistics from './ParkingSpaceDetail/OverviewStatistics.vue';
import DataEditor from './ParkingSpaceDetail/DataEditor.vue';
import notificationHandler from '../../../services/notificationHandler';
import SimpleStatistic from '../Metrics/SimpleStatistic.vue';
import { ParkingLotsApi, ParkingEventsApi } from '../../../api';
import moment from 'moment';

export default {
  name: 'parking-space-detail',

  components: {
    ParkingTable,
    OverviewStatistics,
    DataEditor,
    SimpleStatistic,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      dialog: false,
      tab: 0,
      dataModel: null,
      statistics: null,
      shapeUpdate: false,
      parkingEvents: [],
    };
  },

  watch: {
    data: {
      immediate: true,
      handler() {
        this.dataModel = this.data;
      },
    },
    updateParkingSpaceViaSocket(newVal) {
      if (newVal === -1 && this.dialog) {
        this.getData()
      }
    },
  },

  computed: {
    updateParkingSpaceViaSocket() {
      return this.$store.parkingLots.state.updateParkingSpaceViaSocket;
    },
  },

  filters: {
    // Parses Seconds into HH:mm duration
    durationFromSeconds(seconds) {
      seconds = parseInt(seconds, 10);
      const duration = moment.duration(seconds, 'seconds');
      return moment.utc(duration.asMilliseconds()).format('HH:mm');
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.dialog) {
          this.dialog = false;
        } else {
          this.loading = true;
          this.dialog = true;
          this.getData()
        }
      });
    },
    getData() {
      var dailyStats = ParkingLotsApi.getDailyStats({parking_space_id: this.dataModel.id})
      var parkingEvents = ParkingEventsApi.getEvents({parking_space_id: this.dataModel.id, event_type: "occupied"})
       Promise.all([dailyStats, parkingEvents])
        .then(values => {
          this.statistics = values[0].data;
          this.parkingEvents = values[1].data;
          this.loading = false;
        });
    },
    onParkingSpaceDeleted() {
      const validation = prompt('Bitte gebe "DELETE" in das Feld ein, um den Löschvorgang zu bestätigen');
      if (validation === 'DELETE') {
        this.$store.parkingLots.dispatch('DELETE_PARKING_SPACE', {
          parkingLotId: this.$route.params.id,
          parkingSpaceId: this.dataModel.id,
        })
          .then(() => {
            notificationHandler.showNotification(`Parkplatz ${this.dataModel.id} wurde gelöscht.`, 'snackbar:selfClosed');
            this.dialog = false;
            this.$emit('delete', this.dataModel.id);
          });
      }
    },
    onParkingSpaceUpdate(payload) {
      this.$store.parkingLots.dispatch('UPDATE_PARKING_SPACE', {
        parkingLotId: this.$route.params.id,
        parkingSpaceId: this.dataModel.id,
        payload,
      })
        .then(() => {
          this.dialog = false;
        });
    },
    onParkingSpaceShapeUpdate() {
      this.shapeUpdate = true;
      this.$emit('parking-space-shape-update', this.dataModel.id);
    },
    setPersistentOfDialog(bool) {
      this.shapeUpdate = bool;
    },
  },
};
</script>
